<template>
  <div>
    <base-title
      :title="StringLanguage.payment"
      :subtitle="
        onBoardDone ? StringLanguage.configurations : StringLanguage.back
      "
      :link="onBoardDone ? 'configuracoes' : 'onboard'"
    >
      <!-- <base-button
        @click="changeRoute('detalhes-integracao', { name: 'juno' })"
        design="two"
        :class="!!isMobile && 'reverse w-100'"
        text="Ir para Juno"
      /> -->
    </base-title>

    <!-- <div class="tabs mb_40">
      <ul>
        <li>
          <a @click="selectedTab = 0" :class="{ active: selectedTab === 0 }"
            >Na entrega</a
          >
        </li>
        <li :class="{ desk: selectedTab == 1 }">
          <a @click="selectedTab = 1" :class="{ active: selectedTab === 1 }"
            >Online</a
          >
        </li>
      </ul>
    </div> -->

    <base-box class="pr_30" v-for="(method, i) in paymentMethods" :key="i">
      <!-- v-for dos métodos -->
      <base-label :text="method.name" class="mb_0" />

      <div class="row">
        <div
          class="col-lg-4 col-md-6 col-xs-12 pr_5"
          v-for="(flag, f) in resumedFlags(method)"
          :key="f"
        >
          <base-checkbox
            v-model="flag.active"
            :checked="flag.active"
            @click="checkFlag(method.type, flag)"
            class="card-flag"
          >
            <!-- v-for de bandeiras visiveis -->
            <div class="d-flex align-center justify-between">
              <div class="d-flex align-center">
                <img
                  v-if="flag.image"
                  :src="`https://cdn.easydelivery.com.br/cards/${flag.alias}.png`"
                  :alt="flag.alias"
                  class="img-flag"
                />
                <img
                  v-else
                  :src="`https://cdn.easydelivery.com.br/cards/DEFAULT.png`"
                  :alt="flag.alias"
                  class="img-flag"
                />
                <span class="flag-name">{{ flag.name }}</span>
              </div>
            </div>
          </base-checkbox>
        </div>

        <div class="col-lg-4 col-md-6 col-xs-12 pr_5" v-if="method.type != 24">
          <p class="add-others" @click="openDrawer(i)">
            <i class="fal fa-plus mr_15"></i> Adicionar bandeira
          </p>
        </div>
      </div>
    </base-box>

    <base-drawer
      title="Adicionar bandeira"
      :open="flagsDrawer"
      :close="flagsDrawerClose"
    >
      <base-card>
        <base-select
          title="Método de pagamento"
          :key="flagsDrawer"
          v-model="selectedMethod"
          :items="
            paymentMethods
              .map((item, i) => {
                return { text: item.name, value: i };
              })
              .filter((item) => item.text != 'Dinheiro')
          "
          @change="selectMethod"
        ></base-select>
        <base-select
          title="Bandeiras"
          class="mb_5"
          :items="newFlagOptions"
          v-model="selectedNewFlag"
        ></base-select>
      </base-card>

      <template v-slot:footer>
        <base-button text="Adicionar" @click="addNewFlag" class="w-100 big" />
      </template>
    </base-drawer>
    <div class="d-flex justify-end w-100" v-if="hasChange">
      <base-button design="save" @click="onSave" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { setTimeout } from 'timers';
import paymentAPI from '@/api/payment';
import storeAPI from '@/api/store';
import { Method, PaymentMethod } from 'easyjs/lib/Schema/Payment';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseCheckbox from '@/components/Checkbox';
import BaseLabel from '@/components/Label';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseSelect from '@/components/Select';

export default {
  data() {
    return {
      Method,
      PaymentMethod,
      loadingData: false,
      payments: [],
      originalData: null,
      flagsDrawer: false,
      flagsDrawerClose: false,
      selectedTab: 0,
      groupsMethodsDefault: [
        {
          name: StringLanguage.credit,
          type: 17,
          default: ['VISA', 'MASTERCARD', 'HIPER', 'ELO', 'AMERICAN_EXPRESS'],
        },
        {
          name: StringLanguage.debit,
          type: 18,
          default: ['VISA', 'MASTERCARD', 'REDESHOP_DEBITO', 'HIPER', 'ELO'],
        },
        {
          name: StringLanguage.voucher2,
          type: 20,
          default: [
            'ALELO_ALIMENTACAO',
            'VR_ALIMENTACAO',
            'SODEXO_ALIMENTACAO',
            'TICKET_ALIMENTACAO',
            'VISA_VALE_ALIMENTACAO',
          ],
        },
        {
          name: StringLanguage.voucher,
          type: 20,
          default: [
            'ALELO_REFEICAO',
            'VR_REFEICAO',
            'SODEXO_REFEICAO',
            'TICKET_RESTAURANTE_REFEICAO',
            'VISA_VALE_REFEICAO',
          ],
        },
        {
          name: StringLanguage.money,
          type: 24,
          default: ['DINHEIRO'],
        },
      ],
      selectedMethods: [],
      paymentMethods: [],
      selectedMethod: 0,
      newFlagOptions: [],
      selectedNewFlag: '',
      hasChange: false,
    };
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseCheckbox,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseSelect,
  },
  beforeRouteLeave(to, from, next) {
    if (!this.selectedMethods.length || this.hasChange) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => {
        if (res) next();
      });
    } else {
      next();
    }
  },
  created() {
    let self = this;
    this.groupsMethods();
  },
  methods: {
    changeRoute(routeName, params = {}) {
      this.$router.push({ name: routeName, params });
    },
    onSave() {
      if (!this.selectedMethods.length) {
        alert(StringLanguage.confirmInfoWithoutLeaveRoute);
      } else {
        this.hasChange = false;
        this.save();
      }
    },
    save() {
      storeAPI
        .storeConfiguration({ payment_methods: this.selectedMethods }, false)
        .then(() => {
          this.$store.dispatch('store/getConfigurations');

          if(!this.onBoardDone) {
            return this.$router.push({ name: "onboard" });
          }

          alert(StringLanguage.saveSuccess);
        })
        .catch((err) => {
          console.log(err)
          alert(StringLanguage.saveError);
        });
    },
    openDrawer(index) {
      this.flagsDrawer = !this.flagsDrawer;
      this.selectedMethod = parseInt(index);
    },
    checkFlag(type, ev) {
      if (!this.hasChange) this.hasChange = true;

      if (this.selectedMethods == undefined) {
        this.selectedMethods = [];
      }

      ev.type = type;
      ev.active = !ev.active;

      if (ev.active) {
        this.selectedMethods.push(ev);
      } else {
        // Procura os pagamentos que são do mesmo tipo e estão contido no array default
        const selectedGroupMethods = this.groupsMethodsDefault
          .filter((group) => group.type == ev.type)
          .map((method) => method.default);

        // Verifica se o pagamento está dentro do mesmo grupo padrão e insere no array
        let methods = [];
        selectedGroupMethods.forEach((method) => {
          methods = [
            ...methods,
            ...method.filter((group) => group == ev.alias),
          ];
        });

        if (methods.length == 0) {
          confirm('Tem certeza que deseja remover essa bandeira?', (op) => {
            if (op) {
              ev.active = !ev.active;
              this.selectedMethods = this.selectedMethods.reduce(
                (p, c) => (c.alias != ev.alias && p.push(c), p),
                []
              );
            }
          });
        } else {
          ev.active = !ev.active;
          this.selectedMethods = this.selectedMethods.reduce(
            (p, c) => (c.alias != ev.alias && p.push(c), p),
            []
          );
        }
      }
    },
    defaultPaymentMethod(method) {
      return (
        this.groupsMethodsDefault
          .map((defaultMethod) => defaultMethod.default)
          .filter((item) => item.includes(method.alias)).length > 0
      );
    },
    selectMethod() {
      const filteredMethodFlags = this.paymentMethods[
        this.selectedMethod
      ].flags.filter((item) => {
        if (
          this.selectedMethods.filter((a) => a.alias == item.alias).length ===
            0 &&
          !this.defaultPaymentMethod(item)
        ) {
          if (this.paymentMethods[this.selectedMethod].type == 20) {
            const aliasOrigin = this.paymentMethods[this.selectedMethod].name
              .split(' ')[1]
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
            const aliasdest = item.alias
              .split('_')
              [item.alias.split('_').length - 1].toLowerCase();

            if (aliasOrigin == aliasdest) {
              return item;
            }
          } else {
            return item;
          }
        }
      });

      this.newFlagOptions = filteredMethodFlags.map((item) => {
        return {
          text: item.name,
          value: item.alias,
        };
      });

      this.selectedNewFlag = this.newFlagOptions[0].value;
    },
    groupsMethods() {
      storeAPI.storeGetConfiguration('payment_methods').then((response) => {
        const methodsSelected = response.getData([]);
        this.selectedMethods = methodsSelected.payment_methods || [];

        this.groupsMethodsDefault.forEach((item) => {
          const flags = [];

          for (let i in Method) {
            let selected = false;

            if (methodsSelected.payment_methods) {
              selected = methodsSelected.payment_methods.filter(
                (a) => a.alias == Method[i].alias && a.type == item.type
              )[0];
            }

            if (
              (parseInt(Method[i].type) & parseInt(item.type)) >=
              parseInt(item.type)
            ) {
              flags.push({
                alias: Method[i].alias,
                name: Method[i].name,
                active: selected ? selected.active : false,
              });
            }
          }

          this.paymentMethods.push({
            name: item.name,
            type: item.type,
            default: item.default,
            flags: flags,
          });
        });
      });
    },
    resumedFlags(methods) {
      const flags = [];

      methods.flags.forEach((a) => {
        if (methods.default.filter((b) => b == a.alias).length > 0) {
          a.image = `https://cdn.easydelivery.com.br/cards/${a.alias}.png`;
          flags.push(a);
          return;
        }

        if (
          this.selectedMethods &&
          this.selectedMethods.filter((b) => b.alias == a.alias).length > 0
        ) {
          if (methods.type == 20) {
            const aliasSelected = this.selectedMethods.filter(
              (b) => b.alias == a.alias
            )[0].alias;
            const aliasOrigin = methods.name
              .split(' ')
              [methods.name.split(' ').length - 1].toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
            const aliasdest = a.alias
              .split('_')
              [a.alias.split('_').length - 1].toLowerCase();

            if (aliasOrigin == aliasdest) {
              flags.push(a);
              return;
            }
          } else {
            flags.push(a);
            return;
          }
        }
      });

      flags.sort((paymentA, paymentB) => {
        if (
          Method[paymentA.alias].importance > Method[paymentB.alias].importance
        )
          return -1;
        if (
          Method[paymentA.alias].importance < Method[paymentB.alias].importance
        )
          return 1;
        return paymentA.alias.localeCompare(paymentB.alias);
      });

      return flags;
    },
    addNewFlag() {
      this.checkFlag(
        this.paymentMethods[this.selectedMethod].type,
        this.paymentMethods[this.selectedMethod].flags.filter(
          (a) => a.alias == this.selectedNewFlag
        )[0]
      );
      this.flagsDrawerClose = !this.flagsDrawerClose;
      this.selectedMethod = 0;
      this.selectedNewFlag = '';
    },
    saveMethods() {
      this.loadingData = true;

      let selected = this.payments
        .map((method) => method.flags)
        .reduce((carry, method) => [...carry, ...method], [])
        .filter((method) => method.active)
        .map(({ alias, type }) => ({ alias, type }));

      storeAPI
        .storeConfiguration({ payment_methods: selected })
        .then((response) => {
          if (response.getErrors([]).length > 0) {
            alert(response.getErrors([StringLanguage.loadError])[0]);
            return false;
          }

          this.$store.dispatch('store/getConfigurations');
        })
        .catch((err) => {
          console.log(err);
          alert(StringLanguage.loadError);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
  computed: {
    ...mapState({
      onBoardDone: (state) => state.store.onBoardDone,
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>

<style scoped>
.img-flag {
  width: 30px;
  margin-left: 5px;
}

.flags-box {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;
  padding: 0px 15px;
  background: white;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-radius: 0 0 5px 5px;
  margin-bottom: 15px;
}

.flags-box.open {
  max-height: 2000vh;
  transition: max-height 1s;
}

.method-type {
  padding: 20px 25px;
  border-radius: 5px;
  color: white;
  font-size: 1em;
  font-weight: 900;
  text-transform: uppercase;
  opacity: 0.8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1em;
}

.card-flag {
  padding: 15px;
  display: flex;
  align-items: center;
  background-color: var(--box-up);
  margin-top: 20px;
  border-radius: 5px;
  justify-content: space-between;
  flex-direction: row-reverse;
}

.flag-name {
  font-size: 14px;
  margin-left: 10px;
  font-weight: bold;
  color: var(--label-primary);
}

.no-flag {
  font-size: 2.2em;
  color: #bbb;
}

.add-others {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em;
  padding: 15px;
  font-weight: bold;
  border: 2px dashed #676b73;
  border-radius: 5px;
  cursor: pointer;
  color: var(--label-primary);
  opacity: 0.8;
  transition: all 0.1s ease;
  margin-top: 20px;
}

.add-others:hover {
  filter: brightness(1.1);
}
.tabs ul li {
  display: inline;
  text-align: center;
}
.tabs a {
  cursor: pointer;
  display: inline-block;
  margin-right: 25px;
  margin-bottom: 6px;
  text-decoration: none;
  font-size: 1.4em;
  color: #999999ad;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
}
.tabs a.active {
  color: var(--default);
  border-color: var(--default);
}
</style>
